module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAALCAYAAACgR9dcAAAAAXNSR0IArs4c6QAAAR5JREFUKBVtkTFLQlEYhu8Vw6VNiIyLpPkHqlGHmsLJyV/g5KK4RBAuknPU3i4IWoNDQ7S0+wMC76bRJrg0yPV5L+fEuXI/ePje9/3OOffcez0vpaIoysEdTEzPpSzzfIanDLrwB0vf95/J3tBjeIcbaJI3yDvoE9BhTx7BAKoY6RkcwYe8LXmTz5ShqzDIol/hEfNFX/OEX3QeCuiVOnne5Gv8EF+DHsQnBYR1yBh/gQ5havqlyTN4rQvks4gz+j2UYIv/pKuu4BA2oJsc0K/hFkL8UB9sinmAbyjDC8zhGHTlFfzAObRgARXo6+XbiLjQ+jVF692uXHObof/32c32ynZNorMhMY8/kLNi3zujWCbm+lVujfZPd4foket35ri/Ra6uJJAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/org-selected.png
// module id = 1516
// module chunks = 0